import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal, Overlay, Drawer, Zendesk } from 'components/UIElements'
import { DEFAULT_INACTIVITY_TIMEOUT_SECONDS, SECONDS_IN_MINUTE } from 'utils/constants'
import { multiplyStringByInteger } from 'utils/misc'
import { modalActions } from 'store/modal'
import { authActions } from 'store/user'
import NavBarContainer from '../NavBar'
import SideBarContainer from '../SideBar'
import ErrorBox from '../ErrorBox'
import SessionTimeout from './SessionTimeout'
import './CoreLayout.scss'

const CoreLayout = ({
  children,
  drawer,
  modal,
  overlay,
  location,
  view,
  sessionTimeoutSeconds,
  onLogout,
  openModal,
}) => {
  const { pathname } = location
  const isViewFalse = !['/unauthorized', '/studies', '/users/me'].includes(pathname) && view === false
  const isFull =
    pathname === '/login' ||
    pathname === '/users/reset' ||
    pathname === '/users/activate' ||
    pathname.includes('/insights-permissions') ||
    pathname.includes('/studies/create') ||
    isViewFalse
  const isAllStudiesPath = pathname === '/studies' || pathname === '/studies/'
  const isLoginPage = location.pathname === '/login'
  return (
    <div className='layout-container'>
      <Modal {...modal} location={location} />
      <Overlay {...overlay} />
      <Drawer {...drawer} location={location} />
      {pathname !== '/login' &&
        !pathname.includes('preview') &&
        !pathname.includes('insights-permissions') &&
        !pathname.includes('/participants/create') &&
        !pathname.includes('/participants/caregiver/create') &&
        !pathname.includes('/participants/account-settings') &&
        !isViewFalse ? (
        <SideBarContainer />
      ) : null}
      {pathname !== '/login' &&
        !pathname.includes('preview') &&
        !pathname.includes('insights-permissions') &&
        !pathname.includes('/participants/create') &&
        !pathname.includes('/participants/caregiver/create') &&
        !pathname.includes('/participants/account-settings') &&
        !isAllStudiesPath &&
        !isViewFalse ? (
        <NavBarContainer />
      ) : null}
      {!isLoginPage && sessionTimeoutSeconds > 0 && (
        <SessionTimeout
          onLogout={onLogout}
          openModal={openModal}
          sessionTimeoutSeconds={sessionTimeoutSeconds}
          modal={modal}
        />
      )}
      <div className={isFull ? 'core-layout__viewport full' : 'core-layout__viewport'}>
        <ErrorBox />
        {children}
      </div>
      <Zendesk />
    </div>
  )
}

const mapStateToProps = state => {
  const { drawer, loading, modal, overlay, study, user, view } = state
  const config = study?.currentStudy?.config || {}
  const sessionTimeoutMinutesFromAdminSecurity = Number(config?.admin_security?.session_timeout)
  const sessionTimeoutSeconds =
    Number.isFinite(sessionTimeoutMinutesFromAdminSecurity) && sessionTimeoutMinutesFromAdminSecurity > 0
      ? multiplyStringByInteger(sessionTimeoutMinutesFromAdminSecurity, SECONDS_IN_MINUTE)
      : DEFAULT_INACTIVITY_TIMEOUT_SECONDS
  return {
    loading: loading.general,
    view: view,
    modal: modal,
    overlay: overlay,
    drawer: drawer,
    permissions: user.permissions,
    sessionTimeoutSeconds,
  }
}

const mapDispatchToProps = {
  onLogout: authActions.logout,
  openModal: modalProps => modalActions.openModal(modalProps),
  closeModal: modalActions.closeModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout)

CoreLayout.propTypes = {
  children: PropTypes.node, // may be null when a child route renders nothing before redirect (e.g. auth)
  location: PropTypes.shape({
    general: PropTypes.bool,
  }),
  modal: PropTypes.shape({
    open: PropTypes.bool,
  }),
  sessionTimeoutSeconds: PropTypes.number,
}
